export default __webpack_public_path__ + "static/media/227.9c92896b.gif";